var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "81%",
    viewBox: "0 0 44 36",
    fill: "#0067FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26 2.02256V9.67116C26 16.9437 34.9526 21 34.9526 21C34.9526 21 43.9051 16.9437 43.9051 9.67116V2.02256C43.9051 2.02256 40.7 0 34.9526 0C29.2051 0 26 2.02256 26 2.02256Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9526 0C29.2051 0 26 2.02256 26 2.02256V9.67116C26 16.9437 34.9526 21 34.9526 21V0Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13C39 13 37.794 14 34.5 14C31.206 14 30 13 30 13C30 13 34.5 14 39 13Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7C41.293 7.83578 39.3767 8.2242 37.7199 7.86756C36.9463 7.70104 36.3301 7.3902 36 7H42Z",
    fill: "#888888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 2.82994V9.75009C0 16.33 8.09994 20 8.09994 20C8.09994 20 16.1999 16.33 16.1999 9.75009V2.82994C16.1999 2.82994 13.3 1 8.09994 1C2.89988 1 0 2.82994 0 2.82994Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09994 1C2.89988 1 0 2.82994 0 2.82994V9.75009C0 16.33 8.09994 20 8.09994 20V1Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.8372C11.5 12.8372 11.4501 12.3372 8.50003 12.3372C5.54998 12.3372 5 13.3372 5 13.3372C5 13.3372 7.46992 15.5872 11.5 12.8372Z",
    fill: "#888888"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94204 6.69346C6.34562 5.29578 4.72913 4.64621 3.33144 5.24264C2.67891 5.5211 2.15908 6.04093 1.88062 6.69346H6.94204Z",
    fill: "#888888"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9 14.3115V23.0528C9 31.3643 19.2315 36 19.2315 36C19.2315 36 29.463 31.3643 29.463 23.0528V14.3115C29.463 14.3115 25.8 12 19.2315 12C12.663 12 9 14.3115 9 14.3115Z",
    fill: "inherit"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2315 12C12.663 12 9 14.3115 9 14.3115V23.0528C9 31.3643 19.2315 36 19.2315 36V12Z",
    fill: "inherit"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3219 25.4528C24.3219 25.4528 22.9576 28.9264 19.2313 28.9264C15.5049 28.9264 14.1406 25.4528 14.1406 25.4528C14.1406 25.4528 19.2313 28.9264 24.3219 25.4528Z",
    fill: "#888888"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7689 19.1917C17.0155 17.4262 14.9736 16.6057 13.2081 17.3591C12.3839 17.7109 11.7272 18.3675 11.3755 19.1917H17.7689Z",
    fill: "#888888"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0872 19.1917C26.3338 17.4262 24.292 16.6057 22.5265 17.3591C21.7022 17.7109 21.0456 18.3675 20.6938 19.1917H27.0872Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactions);
export default __webpack_public_path__ + "static/media/icon-factions.95f29b510b908f745a6c7982de811651.svg";
export { ForwardRef as ReactComponent };